import {ReactNode} from 'react'
import classNames from 'classnames'
import StoreLink from './StoreLink'

type Props = {
  classes?: string[],
  children: ReactNode,
}

export default function StoryContainer(props: Props) {
  const classes = classNames([...(props?.classes || []), 'story'])
  return (
    <div className={classes}>
      {props.children}
      <StoreLink />
    </div>
  )

}
